<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M14.683 7.20078L9.81691 12.3168C9.32876 12.805 8.5373 12.805 8.04914 12.3168L2.93304 7.20078C2.44489 6.71262 2.44489 5.92117 2.93304 5.43301C3.4212 4.94486 4.21265 4.94486 4.70081 5.43301L8.93304 9.66517L12.9152 5.43301C13.4033 4.94486 14.1948 4.94486 14.683 5.43301C15.1711 5.92117 15.1711 6.71262 14.683 7.20078Z"
    />
  </svg>
</template>
